const $nbb = $(".nbb")
const $bar = $(".nbb__bar")
const $main = $(".nbb__main")
let chosenBundleProducts = [];
$(".nbb__mobile-bar").click(() => $(".nbb__mobile").toggleClass("open"))

function detectBarScroll() {
  $nbb.toggleClass('show', (window.scrollY || window.pageYOffset) > 400);
}

detectBarScroll();
window.addEventListener('scroll', detectBarScroll);

getExistingBundle();

$(".nbb__bar").click((e) => {
  e.preventDefault();
  document.querySelector("cart-drawer").close();
  $nbb.toggleClass("open");
})

$(document).on("click", "[data-open-bundle]", (e) => {
  e.preventDefault();
  document.querySelector("cart-drawer").close();
  $nbb.addClass("open");
})

$("[data-filter-quantity-selector], [data-filter-quantity-plus], .nbb__checkout").click(function(e) {
  e.preventDefault();
  e.stopPropagation();
})

$("[data-filter-quantity-plus]").click(function() {$nbb.addClass("open");addToBundle(getProductId(this))})

$("[data-filter-quantity-minus]").click(function() {removeFromBundle(getProductId(this))})

function addToBundle(value) {
  if (chosenBundleProducts.length > 5) return;
  chosenBundleProducts.push(value);
  
  updateBundle();
}

function removeFromBundle(value) {
  if (chosenBundleProducts.length < 1) return;
  const index = chosenBundleProducts.indexOf(value);
  if (index > -1) {
    chosenBundleProducts.splice(index, 1);
  }
  
  updateBundle();
}

function getProductId(el) {
  return el.closest("[data-variant-id]").dataset.variantId;
}

updateBundle()
function updateBundle() {
  //Update quantity selector
  $(".nbb .filter-product").each(function() {
    const count = chosenBundleProducts.filter(item => item == this.dataset.variantId).length;
    $(this).find(".filter-product__plus").toggleClass("hidden", count > 0);
    $(this).find(".filter-product__quantity-wrapper").toggleClass("hidden", count < 1);
    $(this).find("[data-filter-quantity]").text(count);
  })

  //Badges
  $(".nbb__flavour img").removeAttr("src")
  $(".nbb__flavour img").addClass("hidden")
  const $badges = $(".nbb .all-badges")
  $(".nbb__flavour .nbb__flavour-text").addClass("hidden")
  chosenBundleProducts.forEach((id, index) => {
    const productInfo = bundleProductInfo.find(product => product.id == id);
    if (!productInfo) {removeFromBundle(id);return;}

    const $flavour = $($(".nbb__info .nbb__flavour").get(index));
    const $flavour_mob = $($(".nbb__mobile .nbb__flavour").get(index));

    $flavour.find("img").attr("src", productInfo.badge);
    $flavour.find("img").removeClass("hidden");
    $flavour.find(".nbb__flavour-text").text(productInfo.title)
    $flavour.find(".nbb__flavour-title").removeClass("hidden");
    $flavour_mob.find("img").attr("src", productInfo.badge);
    $flavour_mob.find("img").removeClass("hidden");
    $flavour_mob.find(".nbb__flavour-text").text(productInfo.title)
    $flavour_mob.find(".nbb__flavour-title").removeClass("hidden");
  })

  $("[data-num-chosen]").text(chosenBundleProducts.length);

  //Localstorage
  localStorage.setItem('chosenBundleProducts', chosenBundleProducts.toString());

  //Checkout Button Text
  if (chosenBundleProducts.length > 5) {
    $(".nbb__checkout").removeAttr("disabled")
    $("[data-not-full-case-text]").hide();
    $("[data-full-case-text]").show();
  }
  else {
    $(".nbb__remaining-flavours").text(6 - chosenBundleProducts.length);
    $(".nbb__checkout").attr("disabled", "");
    $("[data-not-full-case-text]").show();
    $("[data-full-case-text]").hide();
  }
}

function getExistingBundle() {
  const existingChoices = localStorage.getItem("chosenBundleProducts");
  if (existingChoices) {
    chosenBundleProducts = existingChoices.split(",");
    updateBundle();
  }
}

function resetBundle() {
  localStorage.removeItem("chosenBundleProducts");
  chosenBundleProducts = [];
  updateBundle();
}

$(".nbb__checkout").click(async function() {
  if (chosenBundleProducts.length < 6) return;
  const boxVariantId = '42850657239093'
  const cartEle = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const sections = cartEle.getSectionsToRender().map((section) => section.id);
  
  const countMap = chosenBundleProducts.reduce((acc, id) => {
    acc[id] = (acc[id] || 0) + 1;
    return acc;
  }, {});
  
  const properties = {};
  Object.keys(countMap).forEach((key) => {
    properties["_pvgid://shopify/ProductVariant/" + key] = countMap[key];
    const title = bundleProductInfo.find(info => info.id == key).title;
    properties[title] = countMap[key];
  });
  const items = [
    {
      id: boxVariantId,
      quantity: 1,
      properties
    }
  ]

  $.ajax({
    url: window.Shopify.routes.root + 'cart/add.js',
    type: 'post',
    data: { items, sections },
    dataType: "json",  
    success: function(response) {
      setTimeout(() => { cartEle.renderContents(response); }, 100);
      if (cartEle && cartEle.classList.contains('is-empty')) cartEle.classList.remove('is-empty');
      resetBundle();
    },
    error:function(err){
      console.error(err)
    }
  });
})

$(".filter-product").click(function() {
  $(".filter-product__preview-wrapper").addClass("hidden")
  $(this).find(".filter-product__preview-wrapper").removeClass("hidden")
})

$(".filter-product__preview-close").click(function(e) {
  e.preventDefault();
  e.stopPropagation();
  console.log(this.closest(".filter-product__preview-wrapper"))
  this.closest(".filter-product__preview-wrapper").classList.add("hidden")
})